<template>
  <LlScrollableWrap
    v-model="position"
    @scroll-search="$_getMoreListData()"
  >
    <LlScrollableBlock :title="$t(pageTitle)">
      <AppFilterBar
        v-model="filterState"
        class="mt-20 mb-40"
        :filter-fields="filterFields"
      />
      <div class="tab-content">
        <div class="license-card-list">
          <LlEmptyPic
            v-if="!isLoading && listData.length === 0"
            :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
            :title="$t('找不到符合篩選條件的結果')"
          />
          <LicenseCardList
            v-else
            ref="licenseList"
            :to="to"
            :license-list="_listData"
            :isloading="isLoading"
            :query="query"
          />
        </div>
      </div>
      <DotLoading v-if="isScrollLoading" />
    </LlScrollableBlock>
  </LlScrollableWrap>
</template>

<script>
import H_card from '@/helpers/card';
import H_systemClassMenu from '@/helpers/systemClassMenu';
export default {
  name: "CardListModelLayout",
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
    filterStateProps: {
      type: Object,
      required: true,
    },
    filterFields: {
      type: Array,
      required: true,
    },
    to: {
      type: String,
      default: "",
    },
    fetchUrl: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
    },
    cardFields: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
    },
  },
  data() {
    return {
      position: { scrollTop: 0, scrollLeft: 0 },
      filterState: null,
      isLoading: true,
      isScrollLoading: false,
      listData: [],
      page: 1,
      listLastPage: 1,
      isMounted: false,
    };
  },
  computed: {
    _listData() {
      if (this.listData.length > 0) {
        return this.listData;
      } else {
        const empty = [];
        for (let i = 1; i <= 20; i++) {
          empty.push({});
        }
        return empty;
      }
    }
  },
  watch: {
    filterState: {
      deep: true,
      async handler(newValue, oldValue) {
        if (!oldValue || !this.isMounted) return;
        await this.$_init('start');
        this.$emit('input', this.filterState);
      },
    },
    isLoading: {
      handler() {
        this.$emit('loading', this.isLoading);
      },
      immediate: true,
    }
  },
  async mounted() {
    this.filterState = this.filterStateProps;
    await this.$_init("start");
    this.isMounted = true;
  },
  methods: {
    async $_init(type) {
      this.isLoading = true;
      const res = await this.$_fetchListData(type);
      this.listData = this.$_setListData(res);
      this.isLoading = false;
    },
    async $_fetchListData(type) {
      const _params = this.$_getParams();
      if (type === "start") {
        this.page = 1;
      } else {
        this.isScrollLoading = true;
      }
      try {
        const res = await this.$axios.get(this.fetchUrl, {
          params: {
            ...this.params,
            ..._params,
            page: this.page,
            order_by: "created_at",
            order_way: "desc",
          },
        });
        let allListData = res.data.data;
        this.listLastPage = res.data.meta.last_page;
        if (type === "start") {
          return allListData;
        } else {
          const orderedData = allListData;
          this.listData = this.listData.concat(this.$_setListData(orderedData));
          this.isScrollLoading = false;
          this.$_getMoreListData();
          return null;
        }
      } catch (error) {
        alert(error);
      }
    },
    $_setListData(list) {
      if (!list) return;
      let listData = list.map((item) => {
        const name = item.name ? item.name : "";
        let content = [];
        this.cardFields.forEach((field) => {
          if (item.last_version[`${field.value}`] !== undefined) {
            content.push({
              title: field.title,
              text: item.last_version[`${field.value}`]
                ? item.last_version[`${field.value}`]
                : this.$t("無"),
            });
          } else if (item[`${field.value}`] !== undefined) {
            content.push({
              title: field.title,
              text: item[`${field.value}`]
                ? item[`${field.value}`]
                : this.$t("無"),
            });
          }
          let originalText = content[content.length - 1].text;
          if (field.type === "time") {
            content[content.length - 1].text =
              this.$moment(originalText).format("YYYY-MM-DD");
          }
          if (field.type === "number") {
            originalText === this.$t("無")
              ? (content[content.length - 1].text = 0)
              : null;
          }
          if (field.type === "name") {
            content[content.length - 1].text = originalText.name;
          }
        });
        return {
          id: item.id,
          name,
          badges: H_card.setTags(item, ['updated', 'status']),
          system_subclasses: item.system_subclasses,
          content,
          isCardBorderTopHasColor: true,
        };
      });
      return listData;
    },
    $_getMoreListData() {
      const allScrollHeight =
        this.position.scrollTotalHeight - this.position.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      let contentWrap = {};
      if (!this.$refs.licenseList) return;
      contentWrap = this.$refs.licenseList.$el.getBoundingClientRect();
      if (
        contentWrap.height < window.innerHeight ||
        (scrollHeight / allScrollHeight > 0.9 && !this.isScrollLoading)
      ) {
        if (this.page < this.listLastPage) {
          this.page += 1;
          this.$_fetchListData();
        }
      }
    },
    $_getParams() {
      let params = {};
      if (this.filterState.system_subclasses !== undefined) {
        const field = (this.filterFields || []).find(item => item.name === 'system_subclasses');
        const menu = field?.items || [];
        const systemParam = H_systemClassMenu.toSubclassFilterApiParam(
          this.filterState.system_subclasses,
          H_systemClassMenu.getLeafIdsFromClassificationMenu(menu).length,
        );
        if (systemParam !== undefined) {
          params = {
            ...params,
            system_subclasses: systemParam,
          };
        }
      }
      if (this.filterState.search !== undefined) {
        params = {
          ...params,
          search: this.filterState.search,
        };
      }
      if (
        this.filterState.license_type !== undefined &&
        this.filterState.license_type !== "all"
      ) {
        params = {
          ...params,
          license_type: this.filterState.license_type,
        };
      }
      return params;
    },
    $_setListDataWithDateOrder(listData) {
      let result = [];
      listData.forEach((data) => {
        if (result.length === 0) {
          result.push(data);
        } else {
          let length = result.length;
          for (let i = 0; i < length; i++) {
            if (
              this.$moment(data.last_version.updated_at).isAfter(
                result[i].last_version.updated_at,
                "day"
              )
            ) {
              result.unshift(data);
              break;
            } else if (
              this.$moment(data.last_version.updated_at).isBefore(
                result[length - 1].last_version.updated_at,
                "day"
              )
            ) {
              result.push(data);
              break;
            } else {
              continue;
            }
          }
        }
      });
      return result;
    },
  },
};
</script>